export default __webpack_public_path__ + "static/media/first-slide-large.61ac09c7.jpg";